import * as actionTypes from 'constants/ActionTypes';

const reqLDRates = (state = {
    isLoaded: false,
    pagination: {},
    searchText: '',
}, action) => {
    switch (action.type) {
        case actionTypes.DELETE_REQ_LD_RATES:
        case actionTypes.EDIT_REQ_LD_RATES:
        case actionTypes.GET_REQ_LD_RATES:
            return {
                ...state,
                ...action.data.data,
                isLoaded: true,
            };
        default:
            return state;
    }
};

export default reqLDRates;


// WEBPACK FOOTER //
// ./app/reducers/reqLDRates.js